export const CITIES = [
  { slug: "horsens", name: "Horsens" },
  { slug: "vejle", name: "Vejle" },
  { slug: "aarhus", name: "Aarhus" },
  { slug: "skanderborg", name: "Skanderborg" },
  { slug: "juelsminde", name: "Juelsminde" },
  { slug: "aalborg", name: "Aalborg" },
  { slug: "herning", name: "Herning" },
  { slug: "randers", name: "Randers" },
  { slug: "fredericia", name: "Fredericia" },
  { slug: "kolding", name: "Kolding" },
  { slug: "esbjerg", name: "Esbjerg" },
  { slug: "silkeborg", name: "Silkeborg" },
  { slug: "viborg", name: "Viborg" },
  { slug: "odense", name: "Odense" },
  { slug: "svendborg", name: "Svendborg" },
  { slug: "middelfart", name: "Middelfart" },
];

export function getCityBySlug(slug) {
  if (!slug) return null;
  const normalized = slug.toLowerCase().trim();
  return CITIES.find((c) => c.slug === normalized) || null;
}
